export default __webpack_public_path__ + "static/media/kaapsebanner.3169acc4.jpg";